import FilePickerErrorMessageViewState from '../../store/schema/FilePickerErrorMessageViewState';
import FilePickerErrorMessageType from '../../types/FilePickerErrorMessageType';
import { action } from 'satcheljs/lib/legacy';

export default action('showFilePickerErrorMessage')(function showFilePickerErrorMessage(
    message: FilePickerErrorMessageType,
    viewState: FilePickerErrorMessageViewState
) {
    viewState.message = message;
    viewState.isShown = true;
});
